import React from 'react';
import { styles } from './CompetitionStatusTile.css';

const MISSING_DATE_FALLBACK_STRING = 'TBC';

export interface CompetitionStatusTileProps {
  heading: string;
  coverImageSrc: string;
  coverImageAlt: string;
  termsHref: string;
  isClosed?: boolean;
  closeDate?: string;
  hasWinners?: boolean;
  winners?: string;
  winnerAnnouncementDate?: string;
}

export const CompetitionStatusTile: React.FC<CompetitionStatusTileProps> = ({
  heading,
  coverImageSrc,
  coverImageAlt,
  isClosed = false,
  closeDate,
  termsHref,
  winners,
  winnerAnnouncementDate,
  hasWinners,
}) => {
  return (
    <div className={styles.container}>
      <img src={coverImageSrc} alt={coverImageAlt} className={styles.cover} />
      <div>
        <h3 className={styles.heading}>{heading}</h3>
        <div className={styles.contents}>
          {isClosed ? (
            <strong>Closed</strong>
          ) : (
            <>
              <strong>Closes: </strong>
              {closeDate || MISSING_DATE_FALLBACK_STRING}
            </>
          )}
          <br />
          <strong>Winners: </strong>
          {hasWinners
            ? winners || 'Announced soon'
            : `Announced ${winnerAnnouncementDate || MISSING_DATE_FALLBACK_STRING}`}
        </div>
        {termsHref ? (
          <a href={termsHref} className={styles.terms}>
            View full terms and conditions
          </a>
        ) : null}
      </div>
    </div>
  );
};
